<app-page-wrapper>
  <app-loading-spinner *ngIf="!allListItems;else main_content"></app-loading-spinner>

  <ng-template #main_content>
    <h1 class="d-flex">
      Organizations
      <div class="ml-auto d-flex">
        <button class="btn btn-primary" routerLink="/organizations/create-root">+ ADD</button>
      </div>
    </h1>
    <div class="d-flex justify-content-between mb-3" *ngIf="allListItems.length">
      <div class="text-nowrap">
        <input class="form-control search-input d-inline" (input)="onInput(searchBox.value);queueSearchTerm(searchBox.value)"
          placeholder="Search" #searchBox id="search-box" name="org-search-val">
        <!-- <span *ngIf="searching" class="ml-2">
          <i class="fal fa-spinner fa-spin" style="font-size: 1rem"></i>
        </span> -->
      </div>
      <!-- <div *ngIf="!searchValue">
        <button class="btn btn-filter mr-2" [ngClass]="typeFilter ? 'btn-light' : 'btn-selected'" (click)="filterOnType()">All</button>
        <button class="btn btn-filter mr-2" [ngClass]="typeFilter === 'ADM' ? 'btn-selected' : 'btn-light'" (click)="filterOnType('ADM')">Districts</button>
        <button class="btn btn-filter" [ngClass]="typeFilter === 'SCH' ? 'btn-selected' : 'btn-light'" (click)="filterOnType('SCH')">Schools</button>
      </div> -->
    </div>
    <app-org-list [orgs]="searchValue ? (listItems$ | async) : orgs" [showParent]="!!searchValue" [noMatches]="noMatches"
      [loading]="searching" [showType]="true"></app-org-list>
  </ng-template>

</app-page-wrapper>
